import { AllowedOnceEvents } from '../types'

export type JwPlayerEventHandler = (...args: unknown[]) => void

const JW_PLAYER_EVENT_REGISTER_FN = 'once'

const getPlayerWithInterceptedEvent = (
  jwPlayer: jwplayer.JWPlayer,
  eventNames: AllowedOnceEvents[],
  interceptor: (
    originalHandler: JwPlayerEventHandler,
    ...args: unknown[]
  ) => void,
) => {
  const decorateHandler = (
    event: string,
    eventHandler: JwPlayerEventHandler,
  ) => {
    if ((eventNames as string[]).includes(event)) {
      return (...args: unknown[]) => {
        interceptor(eventHandler, ...args)
      }
    }
    return eventHandler
  }

  const handler: ProxyHandler<jwplayer.JWPlayer> = {
    get(player, prop, receiver) {
      if (prop === JW_PLAYER_EVENT_REGISTER_FN) {
        return (
          event: AllowedOnceEvents,
          eventHandler: JwPlayerEventHandler,
        ) => {
          player.once(event, decorateHandler(event, eventHandler))
        }
      }
      return Reflect.get(player, prop, receiver)
    },
  }
  return new Proxy(jwPlayer, handler)
}

export default getPlayerWithInterceptedEvent
